import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { FaultLevel } from './globalSlice';
import { QueryParams } from '../apis/helpers';

interface HealthState extends Pick<QueryParams, 'faultLevel'> {}

const initialState: HealthState = {
  faultLevel: FaultLevel.One,
};

const healthSlice = createSlice({
  name: 'health',
  initialState: { ...initialState },
  reducers: {
    setFaultLevel: (state, action: PayloadAction<FaultLevel>) => {
      state.faultLevel = action.payload;
    },
  },
});

export const { setFaultLevel } = healthSlice.actions;

export default healthSlice.reducer;
